import { ReactElement } from 'react';
import Grid from '@mui/material/Grid';

// Styles
import styles from './NoBlueprintContent.module.scss';

export const NoBlueprintContent = (): ReactElement => {
  return (
    <Grid container>
      <Grid className={styles.container} size={{ xs: 12 }}>
        No blueprint entered yet. Go ahead and upload.
      </Grid>
    </Grid>
  );
};
